import type { PrimaryEntityId } from "../doc/primaryEntityId";
import type { DocEntityBase } from "../entities/docEntityBase";

export enum CipType {
  CONCRETE = "CONCRETE",
}

export interface CipBase<T extends CipType> extends DocEntityBase<"CIP_COMPONENT"> {
  readonly id: PrimaryEntityId<"CIP_COMPONENT">;
  readonly name: string;
  readonly cipType: T;
}

export interface CipConcrete extends CipBase<CipType.CONCRETE> {
  readonly thickness: number;
}

export type CipComponentEntity = CipConcrete;

export type CipComponentId = CipComponentEntity["id"];

export type CipComponentEntityTable = {
  [id: CipComponentId]: CipComponentEntity;
};
